import {defineStore} from 'pinia'
import {Platform} from 'quasar'

const name = 'layout'

function storedIsDark() {
  try {
    return JSON.parse(localStorage.getItem("layout.store"))?.is_dark === true
  } catch (e) {
    return false
  }
}

// Largeur du menu de gauche (px) : valeur par défaut et bornes du redimensionnement
export const LEFT_SIDE_WIDTH = {default: 250, min: 200, max: 600}

function storedLeftSideWidth() {
  try {
    const width = Number(JSON.parse(localStorage.getItem("layout.store"))?.left_side_width)
    return width >= LEFT_SIDE_WIDTH.min && width <= LEFT_SIDE_WIDTH.max ? width : LEFT_SIDE_WIDTH.default
  } catch (e) {
    return LEFT_SIDE_WIDTH.default
  }
}

export const useLayoutStore = defineStore(name, {

  id: name,

  state: () => ({
      page_title: "",
      page_subtitle: "",
      show_reverse_nav: false,
      searchFilter: "",
      canShowFilter: false,
      left_side_state: true,
      left_side_width: storedLeftSideWidth(),
      is_dark : storedIsDark(),
      back_route : undefined,
      // Fiche affichée seule, sans le menu de gauche : {name, id} de sa route (non mémorisé)
      focus_route : undefined,
      // Arbre du référentiel : endroit à rétablir au retour d'une fiche (voir referentialTreeDialog)
      tree_state : null,
    }
  ),

  actions: {
    setBackRoute(options) {
      this.back_route = options
    },
    resetBackRoute() {
      this.back_route = undefined
    },
    setFocusRoute(route) {
      this.focus_route = route
    },
    setTreeState(state) {
      this.tree_state = state
    },
    setPageTitle(title) {
      this.page_title = title
    },
    setPageSubTitle(subtitle) {
      this.page_subtitle = subtitle
    },
    setShowReverseNav(show) {
      this.show_reverse_nav = show
    },
    setSearchFilter(searchTxt) {
      this.searchFilter = searchTxt
    },
    setCanShowFilter(flag) {
      this.canShowFilter = flag
    },
    toggleLeftSideState() {
      this.left_side_state = !this.left_side_state;
    },
    /** Largeur du menu de gauche, ramenée dans ses bornes (mémorisée à la fin du redimensionnement) */
    setLeftSideWidth(width) {
      this.left_side_width = Math.round(Math.min(Math.max(width, LEFT_SIDE_WIDTH.min), LEFT_SIDE_WIDTH.max))
    },
    toggleDarkMode() {
      this.is_dark = !this.is_dark;
      this.updateStorage()
    },
    updateStorage() {
      let layout = {
        page_title: this.page_title,
        page_subtitle: this.page_subtitle,
        show_reverse_nav: this.show_reverse_nav,
        searchFilter: this.searchFilter,
        canShowFilter: this.canShowFilter,
        left_side_state: this.left_side_state,
        left_side_width: this.left_side_width,
        is_dark : this.is_dark
      }

      localStorage.setItem("layout.store", JSON.stringify(layout));
    }
  },
  getters: {
    getBackRoute: (state) => {
      return state.back_route
    },
    darkStyle : (state)=> {
      return state.is_dark ? 'background:white' : 'background:black'
    },
    isDarkMode: (state)=> {
      return state.is_dark
    },
    getPageTitle: (state) => {
      return state.page_title
    },
    getPageSubTitle: (state) => {
      return state.page_subtitle
    },
    getShowReverseNav: (state) => {
      return state.show_reverse_nav
    },
    getSearchFilter: (state) => {
      return state.searchFilter
    },
    getCanShowFilter: (state) => {
      return state.canShowFilter
    },
    getLeftSideState: (state) => {
      return state.left_side_state
    },
    isMobile : () => {
      let condition = false
      if(Platform.is.mobile!==undefined){
        condition = Platform.is.mobile === true
      }
      return condition
    },
    isDesktop : () => {
      let condition = false
      if(Platform.is.desktop!==undefined){
        condition = Platform.is.desktop === true
      }
      return condition
    }
  }

})
